import { TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTableContainer = styled(TableContainer)(({ theme }) => ({}));

export { PeekTableContainer, PeekTableContainer as default };
